<template>
    <!-- <a-popover
        :title="this.$props.story.title"
        trigger="hover"
        placement="left"
        class="story-area"
    > -->
        <!-- <div slot="content" class="story">
            {{text}}
        </div> -->
        <div class="story-container">
            <div class="container">
                <video :src="this.$props.story.video" class="video" controls></video>
            </div>
        </div>
    <!-- </a-popover> -->
</template>

<script>
  export default {
    name: "Story",
    props: ['story'],
    data() {
      return {
        text: '',
      }
    },
    mounted() {
      fetch(this.$props.story.text)
        .then(res => res.text())
        .then(txt => this.text = txt);
    }
  }
</script>

<style scoped>
    .story-container {
        height: calc(100vh - 100px - 74px - 50px);
        max-height: 1000px;
        display: flex;
        flex-direction: column;
    }

    .container {
        position: relative;
        width: 100%;
        height: calc(100vh - 100px - 74px - 50px - 20px - 10px);
        flex-grow: 1;
        flex-shrink: 1;
    }

    .video {
        position: absolute;
        max-height: 100%;
        max-width: 100%;
        min-height: 75%;
        min-width: 75%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .story {
        width: calc(40vw - 400px);
        height: calc(100vh - 100px - 74px - 50px - 20px - 10px);
        overflow-y: auto;
        margin: -12px -16px;
        padding: 0 16px;
        white-space: pre-wrap;
        word-break: break-all;
        word-wrap: break-word;
    }

    .story::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    .story::-webkit-scrollbar-thumb {
        background: rgb(230, 230, 230);
        border: 1px solid #afafaf;
        border-radius: 20px;
    }

    .story::-webkit-scrollbar-track {
        background: #ffffff;
        border-radius: 20px;
    }

    .story::-webkit-scrollbar-button {
        width: 2px;
        height: 2px;
    }
</style>
